module.exports = __webpack_public_path__ + "img/fig02.4b00be3a.jpg";